import { Stack, Text } from '@loadsmart/miranda-react'

export type ShipmentNotesProps = Readonly<{
  notes?: string
}>

export function ShipmentNotes({ notes }: ShipmentNotesProps) {
  if (!notes) {
    return null
  }

  return (
    <Stack gap="spacing-5">
      <h3>
        <Text variant="heading-sm-bold">Shipment Notes</Text>
      </h3>
      <p style={{ margin: 0 }}>
        <Text>{notes}</Text>
      </p>
    </Stack>
  )
}
